import ImageFallback from 'Components/imagefallback'
import vars from 'Consts/vars'

const ShareGroupButton = (props) => {
	const { isMobile, url, title } = props

	const urlList = {
		facebook: `http://www.facebook.com/sharer.php?s=100&p[url]=${url}&p[images][0]=/images/image.jpg&p[title]=${title}&p[summary]=Summary`,
		twitter: `https://twitter.com/intent/tweet?url=${url}&text=${title}`,
		whatsapp: `whatsapp://send?text=${title} - ${url}`,
	}

	const imageList = {
		facebook: "https://image.femaledaily.com/web-assets/icon/ic-facebook.png",
		twitter: "https://image.femaledaily.com/web-assets/icon/ic-twitter.png",
		whatsapp: "https://image.femaledaily.com/web-assets/icon/ic-wa.png",
		copy: "https://image.femaledaily.com/web-assets/icon/ic-copy.png",
		comment: "https://image.femaledaily.com/web-assets/icon/ic-comment.png",
	}

	const CopyToClipboard = (text) => {
		var dummy = document.createElement('textarea')
		document.body.appendChild(dummy)
		dummy.value = text
		dummy.select()
		document.execCommand('copy')
		document.body.removeChild(dummy)
		alert('Berhasil menyalin link: ' + url)
	}


	if (isMobile) {

		return (
			<>
				<p className="share-article-title">Share Article</p>
				<div className="share-section">
					<a
						href={urlList.facebook}
						target="_blank"
					>
						<ImageFallback
							className="btn-share"
							width={43}
							height={43}
							fallbackSrc={vars.imageBrokenDefault.square}
							src={imageList.facebook}
							alt="button share facebook"
						/>
					</a>
					<a
						href={urlList.twitter}
						target="_blank"
					>
						<ImageFallback
							width={43}
							height={43}
							fallbackSrc={vars.imageBrokenDefault.square}
							className="btn-share"
							src={imageList.twitter}
							alt="button share twitter"
						/>
					</a>
					<a
						href={urlList.whatsapp}
						data-action="share/whatsapp/share"
						target="_blank"
					>
						<ImageFallback
							width={43}
							height={43}
							fallbackSrc={vars.imageBrokenDefault.square}
							className="btn-share"
							src={imageList.whatsapp}
							alt="button share whatsapp"
						/>
					</a>
					<div className="btn-share" onClick={() => CopyToClipboard(url)}>
						<ImageFallback
							width={43}
							height={43}
							fallbackSrc={vars.imageBrokenDefault.square}
							className="btn-share"
							src={imageList.copy}
							alt="button share copy"
						/>
					</div>
				</div>
				<style jsx>
					{`
					.share-section {
						display: grid;
						grid-template-columns: repeat(4, 43px);
						grid-gap: 16px;
						margin: 0;
					}

					.btn-share {
						width: 43px;
						height: 43px;
						cursor: pointer;
						object-fit: contain;
					}

					.share-article-title {
						color: #000;
						font-family: "Roboto";
						font-size: 14px;
						font-style: normal;
						font-weight: 400;
						line-height: 22px;
					}
					`}
				</style>
			</>
		)

	}


	return (
		<>
			<div>
				<div className="share-section-desktop">
					<a
						href={urlList.facebook}
						target="_blank"
					>
						<ImageFallback
							className="btn-share"
							width={43}
							height={43}
							fallbackSrc={vars.imageBrokenDefault.square}
							src={imageList.facebook}
							alt="button share facebook"
						/>
					</a>
					<a
						href={urlList.twitter}
						target="_blank"
					>
						<ImageFallback
							className="btn-share"
							width={43}
							height={43}
							fallbackSrc={vars.imageBrokenDefault.square}
							src={imageList.twitter}
							alt="button share twitter"
						/>
					</a>
					<a
						href={urlList.whatsapp}
						data-action="share/whatsapp/share"
						target="_blank"
					>
						<ImageFallback
							className="btn-share"
							width={43}
							height={43}
							fallbackSrc={vars.imageBrokenDefault.square}
							src={imageList.whatsapp}
							alt="button share whatsapp"
						/>
					</a>
					<div className="btn-share" onClick={() => CopyToClipboard(url)}>
						<ImageFallback
							width={43}
							height={43}
							fallbackSrc={vars.imageBrokenDefault.square}
							src={imageList.copy}
							alt="button share copy"
						/>
					</div>
					<a href="#anchor-comment-list">
						<ImageFallback
							className="btn-share"
							width={43}
							height={43}
							fallbackSrc={vars.imageBrokenDefault.square}
							src={imageList.comment}
							alt="button share comment"
						/>
					</a>
				</div>
			</div>
			<style jsx>
				{`
				.share-section-desktop {
					display: grid;
					row-gap: 16px;
				}

				.btn-share {
					width: 43px;
					height: 43px;
					cursor: pointer;
					object-fit: contain;
				}
				`}
			</style>
		</>
	)
}

export default ShareGroupButton